import { render, staticRenderFns } from "./Panorama.vue?vue&type=template&id=b78c9f54&"
import script from "./Panorama.vue?vue&type=script&lang=js&"
export * from "./Panorama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports